import { render } from "./modal_privacy_policy.vue?vue&type=template&id=c1e64a50"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__